import classNames from 'classnames';
import React from 'react';

import styles from '@/components/global/pills/pill.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  detailsLink?: boolean;
  label?: string;
}

const Pill = (props: Props): React.JSX.Element | null => {
  return (
    <div className={classNames({ [styles['details-link']]: props.detailsLink, [styles.pill]: true })}>
      {props.label && <span className={styles.label}>{props.label}</span>}
      {props.children}
    </div>
  );
};

export default Pill;
